import React from "react";
import gundi_no_results from "../../images/gundi_no_results.png"

type NoResultsProps = {
    headerMsg: string,
    labelMsg: string | JSX.Element
}

const NoResults = ({
    headerMsg,
    labelMsg
}: NoResultsProps) => {
    return (
        <div className="mx-auto">
            <img src={gundi_no_results} alt="empty results icon" className="mx-auto cursor-auto h-[180px] mb-6" />
            <h2 className="text-center text-xl mb-1 dark:text-white transition-colors duration-300">{headerMsg}</h2>
            <h3 className="text-center text-secondary-gray dark:text-neutral-gray-400 mb-4 transition-colors duration-300">{labelMsg}</h3>
        </div>
    )
}

export default NoResults;